import React, {useContext} from 'react'
import {AppContext} from "../context/app-context";
import {getLandingRedirectPathForUser} from "./route-utils";
import {Navigate} from "react-router";
import NotFound from "../views/not-found/NotFound";

// The catch-all route. Every real page, account pages included, has its own
// route, so only addresses that aren't pages land here. Logged-out visitors get
// "Page not found" rather than the login form (securspace-ui#3057).
const UserBasedLandingRedirect: React.FC = () => {
  const appContext = useContext(AppContext)
  const {user, loadingUserDetails} = appContext

  if (!user) {
    // Same as the access-control guard: wait for the session before deciding,
    // so a signed-in user never flashes "Page not found".
    return loadingUserDetails ? <div/> : <NotFound/>
  }

  return (
    <Navigate to={getLandingRedirectPathForUser(user)} replace/>
  )
}

export default UserBasedLandingRedirect
